<template lang="pug">
  div.topbar-quickview-button(title="历史记录")
    i.iconfont.icon-history
</template>

<script>
export default {
  name: 'Quickview'
}
</script>

<style lang="sass" scoped>
.topbar-quickview-button
  cursor: pointer
  width: 60px
  text-align: center
  line-height: 60px
  .iconfont
    font-size: 20px
</style>



// WEBPACK FOOTER //
// Quickview.vue?44c84106